module.exports = __webpack_public_path__ + "static/media/usdt.88d6fe2e.png";